import moment from "moment";

const SUPPORTED_DATE_FORMATS = ["YYYY-MM-DD", "DD/MM/YYYY"];

export function parseDate(dateVal) {
  if (dateVal instanceof Date) {
    return moment(dateVal).isValid() ? new Date(dateVal.getTime()) : null;
  }

  if (
    dateVal === null ||
    dateVal === undefined ||
    typeof dateVal !== "string" ||
    dateVal.trim() === ""
  ) {
    return null;
  }

  const parsedMoment = moment(dateVal.trim(), SUPPORTED_DATE_FORMATS, true);
  return parsedMoment.isValid() ? parsedMoment.toDate() : null;
}

export function isDatePastOrPresent(dateInput) {
  const parsedDate = parseDate(dateInput);

  if (!parsedDate) {
    return false;
  }

  const inputDay = moment(parsedDate).startOf("day");
  const today = moment().startOf("day");

  return inputDay.isSameOrBefore(today);
}
